<template>
  <tbody class="deviceOverview-row"
  :class="[{ 'is-expanded': isExpanded }]">
    <tr
      class="deviceOverview-row__data"
      ref="row"
      @click="toggle();"
      :class="{'cursorClass': overviewStatus ? true : false}"
      >
        <td class="deviceOverview-row__cell">
          <ul class="deviceOverview-row__cell__desc">
            <li>
              <img :src="data.imageUrl" @error="imageLoadError" class="deviceOverview-row__cell__img"/>
            </li>
          </ul>
        </td>
        <td class="deviceOverview-row__cell">
          <ul class="deviceOverview-row__cell__desc">
            <li>
            {{ data.name }}
            </li>
          </ul>
        </td>
        <td class="deviceOverview-row__cell">
          <ul class="deviceOverview-row__cell__desc">
            <li class="deviceOverview-row__cell__desc__details">
            {{ data.serialNumber }}
            </li>
          </ul>
        </td>
        <td class="deviceOverview-row__cell">
          <ul class="deviceOverview-row__cell__desc">
            <li class="deviceOverview-row__cell__desc__details">
              <div :class="getStatusColor(data.location)">
                <icon :is="'VCircleIcon'"></icon>
                <span>{{ data.location }}</span>
              </div>
            </li>
          </ul>
        </td>
        <td class="deviceOverview-row__cell">
          <ul class="deviceOverview-row__cell__desc">
            <li class="deviceOverview-row__cell__desc__details">
              <div>
                <span v-if="data.maintenanceStatus.toLowerCase() === 'vertraagd'" v-tooltip="{content: data.delayedReason, placement: 'bottom'}"><icon :is="'VClockIcon'" title=" "></icon></span>
                <icon :is="'VCircleIcon'" v-else :class="getStatusColor(data.maintenanceStatus)"></icon>
                <span>{{ data.maintenanceStatus }}</span>
              </div>
            </li>
          </ul>
        </td>
        <td class="deviceOverview-row__cell">
          <ul class="deviceOverview-row__cell__desc">
            <li class="deviceOverview-row__cell__desc__details">
            {{ data.plannedMaintenanceDate ? moment(data.plannedMaintenanceDate).format('DD-MM-YYYY') : ''}}
            </li>
          </ul>
        </td>
        <td class="deviceOverview-row__cell justify-content-end">
          <div v-if="overviewStatus">
            <v-button tagelement="button" md primary v-if="isExpanded" @click="toggle()">Toon meer</v-button>
            <v-button tagelement="button" md primary v-else @click="toggle()">Toon minder</v-button>
          </div>
          <div v-else>
            <v-button md cta class="deviceOverview-row__cell__allocateDevice"
            :class="{'btn--disabled': data.location !== 'In depot'}"
            v-tooltip="{content: 'Apparaat aan patient toewijzen', placement: 'left-start', html: false}"
            @click.native="allocateDevice()">
              Toewijzen
            </v-button>
          </div>
        </td>
    </tr>
    <tr class="deviceOverview-row__details" v-show="isExpanded">
      <td class="deviceOverview-row__cell" colspan="7">
        <div class="row grid-padding">
          <div class="col-xs-3">
            <p class="deviceOverview-row__cell__label" ref="device details">
              Laatste onderhoud:
            </p>
          </div>
          <div class="col">
            <p class="deviceOverview-row__cell__value" ref="device details">
              {{ data.lastMaintenanceDate ? moment(data.lastMaintenanceDate).format('DD-MM-YYYY') : ''}}
            </p>
          </div>
        </div>
        <div class="row grid-padding">
          <div class="col-xs-3">
            <p class="deviceOverview-row__cell__label" ref="device details">
              Extern serienummer:
            </p>
          </div>
          <div class="col">
            <p class="deviceOverview-row__cell__value" ref="device details">
              {{ data.externalSerialNumber }}
            </p>
          </div>
        </div>
        <div class="row grid-padding">
          <div class="col-xs-3">
            <p class="deviceOverview-row__cell__label" ref="device details">
              Device firmware version:
            </p>
          </div>
          <div class="col">
            <p class="deviceOverview-row__cell__value" ref="device details">
              {{ data.firmwareVersion }}
            </p>
          </div>
        </div>
        <div class="row grid-padding">
          <div class="col-xs-3">
            <p class="deviceOverview-row__cell__label" ref="device details">
              Vakantieapparatuur:
            </p>
          </div>
          <div class="col">
            <p class="deviceOverview-row__cell__value" ref="device details" v-if="data.isHolidayDevice">
              Ja
            </p>
            <p class="deviceOverview-row__cell__value" ref="device details" v-else>
              Nee
            </p>
          </div>
        </div>
        <div class="row grid-padding">
          <v-button md hollow class="deviceOverview-row__cell__actions" @click.native.prevent="deviceMaintenance()">
            <v-history-icon> </v-history-icon>Onderhoudshistorie
          </v-button>
          <v-button md primary class="deviceOverview-row__cell__actions" @click.native.prevent="deviceRetour()"
          v-if="showRetour(data.location)">
            <v-truck-icon> </v-truck-icon>Retour
          </v-button>
          <v-button md primary class="deviceOverview-row__cell__actions"
            v-if="data.location === 'Bij patiënt' && overviewStatus && !dashboardStatus && data.customerId"
            @click.native.prevent="goToPatientDashboard(data.customerId)">
            Naar patiëntendashboard
          </v-button>
        </div>
      </td>
    </tr>
    <!-- Device actions (retour / maintenance history) pop up -->
    <generic-modal :hasCloseButton="true" v-if="showActionPopup" @close="closeModal" :class="{'maintenanceDetails': showMaintenanceDetails}">
      <template #header v-if="showRetourDetails">
        Apparaat retourneren
      </template>
      <template #header v-else>
        Onderhoudshistorie
      </template>

      <template #body>
        <div class="row deviceOverview-row__deviceDetails">
          <div class="col-md-6"><p><b>Apparaatnaam: </b>{{ data.name }}</p></div>
          <div class="col-md-6"><p><b>Serienummer: </b>{{ data.serialNumber }}</p></div>
        </div>
        <div class="row deviceOverview-row__deviceDetails">
          <div class="col-md-12"><p><b>Extern Serienummer: </b>{{ data.externalSerialNumber }}</p></div>
        </div>
        <hr>
        <div class="row deviceOverview-row__deviceDetails" v-if="showRetourDetails">
          <div class="col-md-12">
            <h4>Retour uitgevoerd door: </h4>
            <div v-for="(pickup, pickupIndex) in deviceRetourDetails.process" :key="pickupIndex">
              <div class="form-group__radio" >
                <input :id="'pickup' + pickup.id" name="retourDeviceProcess" :value="pickup.id" type="radio" v-model="computedRetourDetails.pickUpBy"/>
                <label :for="'pickup'+ pickup.id"><span><span></span></span>{{ pickup.text }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <h4>Reden waarom het apparaat retour gaat: </h4>
            <div v-for="(reason, reasonIndex) in deviceRetourDetails.reasons" :key="reasonIndex">
              <div class="form-group__radio" >
                <input :id="'reason' + reason.id" name="retourDeviceReason" :value="reason.id" type="radio" v-model="computedRetourDetails.reasonCode"/>
                <label :for="'reason'+ reason.id"><span><span></span></span>{{ reason.text }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row deviceOverview-row__maintenanceDetails" v-if="showMaintenanceDetails">
          <div class="col-md-12">
            <v-table class="deviceOverview-row__maintenanceDetails__table" :id="'deviceMaintenanceDetails' + data.equipmentId">
              <thead>
                <v-header-row :data="deviceHistoryDetailsHeader"></v-header-row>
              </thead>
              <tbody class="deviceOverview-row__maintenanceDetails__table__row">
                <tr class="deviceOverview-row__maintenanceDetails__table__row__data" ref="row"
                v-for="(row, index) in deviceHistoryDetails"
                :key="row.Description"
                :index="index">
                  <td>
                    {{ moment(row.OrderDate).format('DD-MM-YYYY') }}
                  </td>
                  <td>
                    {{ row.Description }}
                  </td>
                  <td>
                    <div v-for="(pdf, pdfInd) in row.DigitalDocument"
                      :key="pdf.documentUUID"
                      :index="pdfInd"
                      class="deviceOverview-row__maintenanceDetails__pdf"
                    >
                      <div v-for="(pdfFile, pdfIndex) in pdf.meta"
                        :key="pdfFile.value"
                        :index="pdfIndex"
                        class="deviceOverview-row__maintenanceDetails__pdf"
                      >
                        <a @click="downloadPdf(pdf.documentUUID)">{{ pdfFile.value }}
                        <v-download-icon></v-download-icon></a>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </div>
        <hr>
        <div class="row grid-margin deviceOverview-row__deviceDetails" v-if="showRetourDetails">
          <div class="col-md-12">
            <h4>Opmerkingen </h4>
            <textarea
              rows="4"
              class="deviceOverview-row__deviceDetails__textarea"
              id="deviceOverview-row__deviceDetails-remarks"
              placeholder="Typ hier uw bericht…"
              @input="setRemarks($event.target.value)">
            </textarea>
          </div>
        </div>
      </template>
      <template #footer>
        <v-button tagelement="button" md hollow transparent @click.native="closeModal" v-if="showRetourDetails">Annuleren</v-button>
        <v-button tagelement="button" md primary @click.native="closeModal" v-if="showMaintenanceDetails">Sluiten</v-button>
        <v-button tagelement="button" md primary
         v-if="showRetourDetails"
        :disabled="!computedRetourDetails.pickUpBy || !computedRetourDetails.reasonCode"
        @click.native="saveAction">Bevestigen</v-button>
      </template>
    </generic-modal>

    <!-- Success pop up -->
    <generic-modal v-if="showSuccessPopup">
      <template #body>
        <div class="deviceOverview-row__success" v-if="showSuccessPopup">
          <v-check-circle-icon class="deviceOverview-row__success__icon"></v-check-circle-icon>
          <p v-if="overviewStatus">Retour succesvol doorgegeven, wij verwerken deze zo spoedig mogelijk.</p>
          <p v-else>Toewijzen van apparaat aan de patiënt is succesvol verwerkt.</p>
          <div class="row grid-margin">
            <div class="deviceOverview-row__success__imgHolder">
              <img src='@/static/img/succes_mascot.png' class="deviceOverview-row__success__icon" :class="{'slideInUp animated': showSuccessPopup}">
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <v-button tagelement="a" md primary @click.native="closeSuccessModal">Ga verder</v-button>
      </template>
    </generic-modal>

    <!-- Serial Number pop up -->
    <generic-modal v-if="showSerialNumberPopup">
      <template #body>
        <div class="deviceOverview-row__success" v-if="showSerialNumberPopup">
          <v-check-circle-icon class="deviceOverview-row__success__icon"></v-check-circle-icon>
          <p>Toewijzen van apparaat aan de patiënt is succesvol verwerkt.</p>
          <div class="row grid-margin">
            <div class="deviceOverview-row__success__imgHolder">
              <img src='@/static/img/succes_mascot.png' class="deviceOverview-row__success__icon" :class="{'slideInUp animated': showSerialNumberPopup}">
            </div>
          </div>
          <p class="deviceOverview-row__manualSerialNumberText" v-if="equipmentTexts && equipmentTexts.ownSerialNumberText">{{equipmentTexts.ownSerialNumberText}}</p>
          <v-input-group-simple-2
            id="ExternalSerienummer"
            v-model="data.externalSerialNumber"
            type="text"
            placeholder="Extern SerialNummer"
            class="deviceOverview-row__cell__textbox deviceOverview-row__simple-input"
            :rules="{
              required: false
            }"
          >
          </v-input-group-simple-2>
        </div>
      </template>
      <template #footer>
        <v-button tagelement="a" md primary @click.native="allocateDevice()">Ga verder</v-button>
      </template>
    </generic-modal>
  </tbody>
</template>

<script>
import VCircleIcon from 'icons/Circle'
import VClockIcon from 'icons/Clock'
import VHistoryIcon from 'icons/History'
import VTruckIcon from 'icons/TruckDelivery'
import moment from 'moment'
import GenericModal from '@/components/shared/GenericModal'
import VCheckCircleIcon from 'icons/CheckCircle'
import VDownloadIcon from 'icons/Download'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { mapActions } from 'vuex'
import VTable from '@/components/shared/table/Table'
import VHeaderRow from '@/components/shared/table/rows/HeaderRow'
import {
  currentUserIdentity$,
  equipmentTexts$
} from '@/services';

export default {
  name: 'DeviceOverviewRow',
  components: {
    VCircleIcon,
    VClockIcon,
    VHistoryIcon,
    VTruckIcon,
    GenericModal,
    VCheckCircleIcon,
    VTable,
    VHeaderRow,
    VDownloadIcon
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    overviewStatus: {
      type: Boolean,
      default: false
    },
    patientStatus: {
      type: Boolean,
      default: false
    },
    dashboardStatus: {
      type: Boolean,
      default: false
    }
  },
  subscriptions () {
    return {
      user: currentUserIdentity$,
      equipmentTexts: equipmentTexts$
    }
  },
  data () {
    return {
      isExpanded: false,
      showSuccessPopup: false,
      showActionPopup: false,
      showRetourDetails: false,
      showMaintenanceDetails: false,
      showSerialNumberPopup: false,
      deviceRetourDetails: {
        process: [
          { id: 1, text: 'Apparaat wordt opgehaald door het CTB' },
          { id: 2, text: 'Apparaat moet worden opgehaald door Mediq' }
        ],
        reasons: [
          { id: 418, text: 'Beëindiging therapie' },
          { id: 321, text: 'Omruilen apparaat' },
          { id: 990, text: 'Anders' },
        ]
      },
      computedRetourDetails: {
        pickUpBy: '',
        reasonCode: '',
        remarks: ''
      },
      deviceHistoryDetailsHeader: ['Datum', 'Omschrijving', 'Documenten'],
      deviceHistoryDetails: []
    }
  },
  created () {
  },
  methods: {
    ...mapActions('patient', ['setActivePatient']),
    toggle () {
      if (this.overviewStatus) {
        this.isExpanded = !this.isExpanded
      }
    },
    imageLoadError () {
      console.warn('Image without product')
    },
    moment (...args) {
      return moment(...args)
    },
    getStatusColor (status) {
      const computedStatus = status.toLowerCase()
      if (computedStatus === 'in depot' || computedStatus === 'gereed') {
        return 'deviceOverview-row__cell__desc__details__green'
      }
      if (computedStatus === 'bij patiënt' || computedStatus === 'in behandeling') {
        return 'deviceOverview-row__cell__desc__details__orange'
      }
      if (computedStatus === 'bij mediq' || computedStatus === 'naar mediq' || computedStatus === 'gepland') {
        return 'deviceOverview-row__cell__desc__details__red'
      }
      return 'deviceOverview-row__cell__desc__details__nocolor'
    },
    deviceMaintenance () {
      axios.get('Equipment/GetEquipmentMaintenanceHistory?ExternalId=' + this.data.externalId).then((response) => {
          if (response && response.data && response.data.EquipmentMaintenanceResponse) {
            this.deviceHistoryDetails = []
            response.data.EquipmentMaintenanceResponse.Order.forEach(order => {
              if (order.Description && order.DigitalDocument && order.DigitalDocument.length > 0) {
                this.deviceHistoryDetails.push(order)
                this.showActionPopup = true
                this.showMaintenanceDetails = true
              }
            });
          }

      })
    },
    downloadPdf (documentUUID) {
      axios.get('Equipment/GetEquipmentMaintenanceHistoryPdf?documentUUID=' + documentUUID).then((response) => {
          if (response && response.data) {
            const linkSource = `data:application/pdf;base64,${response.data.Content}`;
            const downloadLink = document.createElement("a");
            const fileName = documentUUID + ".pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
            downloadLink.remove();
          }
      })
    },
    deviceRetour () {
      this.showActionPopup = true
      this.showRetourDetails = true
    },
    allocateDevice () {
      if (this.data.externalSerialNumber === null && !this.showSerialNumberPopup) {
        this.showSerialNumberPopup = true
      } else {
        axios.post('../cmd/AllocateEquipmentToCustomer', {
          CustomerId: store.state.patient.patientGegevens.PatientId,
          UserId: this.user.id,
          EquipmentId: this.data.equipmentId,
          ExternalSerialNumber: this.data.externalSerialNumber
        }).then((response) => {
          if (response && response.data) {
            if (this.showSerialNumberPopup) {
              this.closeSuccessModal()
            } else {
              this.showSuccessPopup = true
            }
          }
        })
      }
    },
    closeModal () {
      this.showActionPopup = false
      this.showRetourDetails = false
      this.showMaintenanceDetails = false
    },
    saveAction () {
      if (this.showRetourDetails) {
        this.computedRetourDetails.equipmentId = this.data.equipmentId
        axios.post('../cmd/DeallocateEquipmentForCustomer', this.computedRetourDetails).then((response) => {
          if (response && response.data) {
            this.closeModal()
            this.showSuccessPopup = true
          }
        })
      }
    },
    setRemarks (remarks) {
      this.computedRetourDetails.remarks = remarks
    },
    closeSuccessModal () {
      this.$emit('retourDevice')
      this.computedRetourDetails =  {
        pickUpBy: '',
        reasonCode: '',
        remarks: ''
      }
      this.showSuccessPopup = false
      this.showSerialNumberPopup = false
      if (!this.dashboardStatus && !this.overviewStatus) {
        router.push('/patientdashboard')
      }
    },
    goToPatientDashboard (patientId) {
      this.setActivePatient(patientId).then((result) => {
        if (result.data.IsActiveCustomer) {
          router.push('/patientdashboard')
        } else {
          this.$store.dispatch('patient/setEndpoints', 'edit')
          router.push('/patientgegevens')
        }
      })
    },
    showRetour (location) {
      return location === 'Bij patiënt' || location === 'In depot'
    }
  }
}
</script>

<style lang="scss" scoped>
.deviceOverview-row {
  background-color: $table-row-background;
  border: $table-row-border;
  transition: $search-transition;
  .maintenanceDetails {
    /deep/
    .generic-modal {
      width: 550px;
    }
  }
  /deep/
  .generic-modal {
    textarea {
      border: solid 1px $gray;
      border-radius: 3px;
      font-style: italic;
      color: $gray-dark;
      padding: 10px;
    }
    h4 {
      margin-bottom: 25px;
    }
    &__success {
      align-items: center;
    }
    hr {
      border: 0;
      width: 95%;
      border-top: solid 2px $gray-light;
    }
  }
  .cursorClass {
    cursor: pointer;
  }
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &__cell {
    @mixin list {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
    color: $table-row-cell-color;
    font-size: $table-row-cell-font-size;
    line-height: $table-row-cell-line-height;
    justify-content: $table-row-cell-justify-content;
    padding: $table-row-license-cell-padding;
    &__actions {
      margin: 15px 0px 15px 25px;
      display: inline-flex;
      .material-design-icon {
        margin-right: 5px;
      }
    }
    &__label {
      color: $table-row-license-cell-prescriber-color;
      font-size: map-get(map-get($type-settings,0), font-size);
      font-weight: bold;
      line-height: $table-row-license-cell-prescriber-line-height;
      margin-top: 0px;
    }
    &__value {
      color: $table-row-license-cell-prescriber-color;
      font-size: map-get(map-get($type-settings,0), font-size);
      font-weight: normal;
      line-height: $table-row-license-cell-prescriber-line-height;
      margin-top: 0px;
    }
    &__desc {
      @include list;
      color: $teal-darkest;
      font-weight: bold;
      &__details {
        color: $black;
        margin-top: 10px;
        .material-design-icon {
          display: inline;
          margin: 0px 5px 0px 0px;
          vertical-align: middle;
          fill: $teal-darkest;
          /deep/ svg {
            width: 15px;
            height: 15px;
          }
        }

        &__green {
          .material-design-icon {
            fill: $cyan-darker;
          }
        }

        &__red {
          .material-design-icon {
            fill: $red;
          }
        }

        &__orange {
          .material-design-icon {
            fill: $orange;
          }
        }

        &__nocolor {
          .material-design-icon {
            fill: transparent;
          }
        }

      }
    }
    &__img {
      @include list;
      max-height: 75px;
      margin-left: 5px;
    }
    &__textbox {
      width: 200px;
    }
  }
  &__simple-input {
    /deep/
    input {
      border-color: #ccc !important;
    }
  }
  &__success {
    text-align: center;
    margin: 0px 0px 20px 0px;
    &__icon {
      fill: $dark-green !important;
      display: inline-block;
      margin: 0px 5px 0px 0px;
      vertical-align: middle;
      /deep/ svg {
        width: 40px;
        height: 40px;
      }
    }
    &__imgHolder {
      border: 2px solid $cyan-darker;
      border-radius: 50%;
      margin: 0px auto;
      box-shadow: 0px 0px 5px $cyan-darker;
      position: relative;
      overflow: hidden;
      img {
        width: 125px;
        height: 125px;
      }
    }
    &__manualSerialNumberText {
      text-align: left;
    }
  }
  &__maintenanceDetails {
    &__pdf {
      cursor: pointer;
      a {
        text-decoration: none;
        color: inherit;
      }
    }
    .material-design-icon {
      fill: $teal-darkest !important;
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
      /deep/ svg {
        height: 16px;
      }
    }
    table {
      width: 100%;
      font-size: 14px;
      margin-bottom: 0px !important;
      > tbody {
        background: $white;
        legend {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        > tr:nth-child(2n) {
          background: $grayish-cyan-light;
        }

        > tr {
          > td, > th {
            min-width: 140px;
            padding: 10px 5px;
          }
        }
        > tr > td:first-child {
          min-width: 100px;
        }
      }
    }
  }
}
</style>
